import React, { FC } from 'react';
import Flex from '../../lib/components/Flex';
import Typography from '../../lib/components/Typography';
import { useExamAnalysisContext } from '../../providers/ExamAnalysisProvider';

const ExamAnalysisStyles: FC = () => {
  const {
    styles,
  } = useExamAnalysisContext();

  if (styles.length === 0) {
    return null;
  }

  return (
    <Flex align="center" className="mb-4" wrap>
      <Typography className="mr-2">Estilos dessa prova:</Typography>
      {
        styles.map((i, idx) => {
          return (
            <>
              {
                idx !== 0 && (
                  <Typography className="mx-2" color="dark-gray">/</Typography>
                )
              }
              <Typography color="dark-gray" tag="small" key={i}>{i}</Typography>
            </>
          );
        })
      }
    </Flex>
  );
};

export default ExamAnalysisStyles;
